// test2887
(2887 && 0);
